<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form ref="form" @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-text>
          <v-text-field
            outlined dense
            v-model="name"
            label="Contact"
            :rules="[required, ]"
            validate-on-blur
          />
          <v-text-field
            outlined dense
            v-model="phone"
            label="Phone Number"
            autocomplete="customer_phone"
            v-mask="'(###) ###-####'"
            :rules="[required, valid_us_phone]"
            validate-on-blur
          />
          <v-text-field
            outlined dense hide-details="auto"
            v-model="zipcode"
            label="Zipcode"
            autocomplete="zipcode"
            :rules="[required, valid_us_zipcode]"
            validate-on-blur
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'
  import { required, valid_us_phone, valid_us_zipcode } from '@/lib/validations'
  import { mapActions } from 'vuex'

  export default {
    name: 'ContactDialog',

    props: ['customer_request'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,

        name: '',
        zipcode: '',
        phone: '',
        email: '',
        
        // validation rules
        required, valid_us_phone, valid_us_zipcode,
      };
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.name = this.customer_request.name
          this.zipcode = this.customer_request.zipcode
          this.phone = this.customer_request.phone
          this.email = this.customer_request.email
        }
      },
    },

    methods: {
      ...mapActions('customer_requests', ['updateCurrent']),
      
      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        if (this.$refs.form.validate()) {
          const payload = {
            customer_request_id: this.customer_request.customer_request_id,
            name: this.name,
            zipcode: this.zipcode,
            phone: this.phone,
            email: this.email,
          }

          let result = await this.updateCurrent(payload)
          if( result.ok ) {          
            this.close()
          }
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>